const pop = {
    state: {
        showPlus: false,  // 因为与首页遮罩层的是否禁用scroll冲突，特加入该属性
                          // 如果该属性为 true， 则在 pop 组件中不执行关闭 scroll 的操作
        show: false,
        title: '',
        content: ''
    },
    mutations: {
        updatePop(state, payload) {
            state.show = payload.show
            state.title = payload.title
            state.content = payload.content
            state.showPlus = payload.showPlus || false
        }
    },
    actions: {
        updatePop(context, payload) {
            setTimeout(function () {
                context.commit('updatePop', payload)
            }, 200)

        }
    }

}

export default pop



// WEBPACK FOOTER //
// ./src/stores/modules/pop.js